import './reports.css';

import FeatureComingSoon from '../../../components/featureComingSoon/featureComingSoon';
import LoadingLogo from '../../../components/loadingLogo/loadingLogo';



export default function Reports() {
    return(
        <div className="no-access">
                        <LoadingLogo/>
                        <p style={{ color: 'red' }}>Feature not ready yet but will be coming Soon!</p>
                      </div>
    )
}